import tippy from "tippy.js";
try {
    tippy('.friend', {
        content(reference) {
            const id = reference.getAttribute('tippy-id');
            const template = document.getElementById(id);
            return template.innerHTML;
        },
        interactive: true
    });
} catch (err) { }

import APlayer from 'aplayer';

import detail from '../data/detail.json';
import lyric from '../data/lyric.json';
try{const ap = new APlayer({
    container: document.getElementsByTagName("APlayer-js")[0],
    lrcType: 1,
    audio: [{
        name: detail.name,
        artist: detail.artists,
        url: 'https://m801.music.126.net/20240412120857/20db4bfc40221c87d8da38ee53a270a7/jdyyaac/obj/w5rDlsOJwrLDjj7CmsOj/14096427141/c08e/402c/e87d/1caf9695a8233cd8e22010d4e7cbd7bb.m4a',
        cover: detail.picUrl,
        lrc: lyric.lyric
    }]
});} catch (err) { }
